/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var TireSeasonType;
(function (TireSeasonType) {
    TireSeasonType["Winter"] = "Winter";
    TireSeasonType["Summer"] = "Summer";
    TireSeasonType["Allseason"] = "Allseason";
})(TireSeasonType || (TireSeasonType = {}));
export function TireSeasonTypeFromJSON(json) {
    return TireSeasonTypeFromJSONTyped(json, false);
}
export function TireSeasonTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function TireSeasonTypeToJSON(value) {
    return value;
}
